"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStore = exports.StoreProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var store_1 = __importDefault(require("./store"));
var storeContext = react_1.default.createContext(null);
var StoreProvider = function (_a) {
    var children = _a.children;
    var store = (0, mobx_react_1.useLocalObservable)(function () { return store_1.default; });
    return ((0, jsx_runtime_1.jsx)(storeContext.Provider, { value: store, children: children }));
};
exports.StoreProvider = StoreProvider;
var useStore = function () {
    var store = react_1.default.useContext(storeContext);
    if (!store) {
        // this is especially useful in TypeScript so you don't need to be checking for null all the time
        throw new Error("useStore must be used within a StoreProvider.");
    }
    return store;
};
exports.useStore = useStore;
